export default function($) {

  const gallerySwiper = new Swiper('.js-gallery-slider', {
    slidesPerView: 1,
    spaceBetween: 16,
    pagination: {
      el: ".gallery-swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 32,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 40,
      },
      1280: {
        slidesPerView: 4,
        spaceBetween: 40,
      }
    },
    navigation: {
      nextEl: '.swiper-button-next-gallery-swiper',
      prevEl: '.swiper-button-prev-gallery-swiper',
    }
  });

  const postsSwiper = new Swiper('.js-posts-slider', {
    slidesPerView: 1.2,
    spaceBetween: 16,
    pagination: {
      el: ".posts-swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
        spaceBetween: 32,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 40,
      }
    },
  });

  const nurseriesSwiper = new Swiper('.js-nurseries-slider', {
    slidesPerView: 1,
    spaceBetween: 16,
    breakpoints: {
      640: {
        slidesPerView: 2,
        spaceBetween: 32,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 40,
      },
      1280: {
        slidesPerView: 4,
        spaceBetween: 40,
      }
    },
    navigation: {
      nextEl: '.swiper-button-next-nurseries-swiper',
      prevEl: '.swiper-button-prev-nurseries-swiper',
    }
  });
};
